import React, { useContext } from 'react';

import { Container } from '../common';
import type { EventTypeEvaluationsContextType } from '../context';
import { EventTypeEvaluationsProvider } from '../context';
import { UserContext } from '~/dashboard/context';
import { ExternalAccountCreatedTabs } from './ExternalAccountCreatedTabs';
import { ExternalAccountCreatedOverview } from './ExternalAccountCreatedOverview';
import { useRiskData } from '../../RiskRatingCard/useRiskData';

const ExternalAccountCreated: React.FC<EventTypeEvaluationsContextType> = props => {
  const { evaluation } = props;
  const { featureFlags, permissions } = useContext(UserContext);
  const hasReadApplicationVersionsPermission = !!permissions?.['READ:ApplicationVersions:null'];
  /* ---------- CRA Logic ---------- */
  const {
    showRiskTab: shouldRenderRiskTab,
    ...riskData
  } = useRiskData({
    isRiskFlagEnabled: featureFlags?.customerRiskAssessmentCra,
    riskScoreData: evaluation.final_response.summary?.risk_score,
  });

  /* ---------- vvvvvvvvv ---------- */

  return (
    <EventTypeEvaluationsProvider {...props}>
      <Container
        evaluationToken={evaluation.evaluation_token}
        entityToken={evaluation.entity_token}
        workflowToken={evaluation.application_token}
        workflowVersion={evaluation.public_version}
      >
        {shouldRenderRiskTab ? (
          <ExternalAccountCreatedTabs
            riskData={riskData}
            canViewRiskFormula={hasReadApplicationVersionsPermission}
          />
        ) : (
          <ExternalAccountCreatedOverview />
        )}
      </Container>
    </EventTypeEvaluationsProvider>
  );
};

export default ExternalAccountCreated;
